export default {
  LOAD_THEORETICAL_PART_STUDENT_LIST_START: 'LoadTheoreticalPartStudentListStart',
  LOAD_THEORETICAL_PART_STUDENT_LIST_END: 'LoadTheoreticalPartStudentListEnd'
};